import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  Grid,
  IconButton,
} from "@material-ui/core";
import { Close } from "@mui/icons-material";
import {
  columnTextField,
  columnNumberField,
  columnPriceField,
} from "utils/tables-utils";
import ToolkitTable from "components/Cards/Tables/ToolkitTable";
import ImagePlaceholder from "components/Image/ImagePlaceholder";

const itemsColumnModel = [
  columnTextField({
    dataField: "UrlFoto",
    text: "Imagem",
    headerAlign: "center",
    align: "center",
    formatter: (_, row) => (
      <ImagePlaceholder
        alt="Imagem do produto"
        src={row.UrlFoto}
        width={64}
        widthOnError={40}
        imagePreviewTitle={`Produto ${row.IdProduto}`}
      />
    ),
  }),
  columnNumberField({
    dataField: "ItemSequencial",
    text: "Item Sequencial",
    align: "center",
  }),
  columnTextField({
    dataField: "SituacaoItemPedido",
    text: "Situação",
    align: "center",
  }),
  columnTextField({
    dataField: "LinhaProduto",
    text: "Linha",
    align: "center",
  }),
  columnTextField({
    dataField: "ColecaoProduto",
    text: "Coleção",
    align: "center",
  }),
  columnNumberField({
    dataField: "IdProduto",
    text: "Id Produto",
    align: "center",
  }),
  columnTextField({
    dataField: "DescricaoProduto",
    text: "Descrição",
  }),
  columnTextField({
    dataField: "CorProduto",
    text: "Cor",
  }),
  columnTextField({
    dataField: "TamanhoProduto",
    text: "Tamanho",
    align: "center",
  }),
  columnTextField({
    dataField: "OD",
    text: "OD",
    align: "center",
  }),
  columnNumberField({
    dataField: "QtdFaturada",
    text: "Qtd Faturada",
    align: "center",
  }),
  columnNumberField({
    dataField: "QtdDevolvida",
    text: "Qtd Devolvida",
    align: "center",
  }),
  columnPriceField({
    dataField: "PrecoUnitario",
    text: "Preço Unitário",
    align: "end",
  }),
  columnPriceField({
    dataField: "ValorLiquido",
    text: "Valor Liquido",
    align: "end",
  }),
  columnTextField({
    dataField: "NomeProduto",
    text: "Nome Produto",
  }),
];

export default function DialogNotaFiscalDetails({ open, onClose, invoice }) {
  if (!invoice) return null;

  const items = invoice.Itens || [
    {
      ItemSequencial: 1,
      SituacaoItemPedido: "Faturado",
      LinhaProduto: "inverno",
      ColecaoProduto: "inverno/2025",
      IdProduto: 123456,
      DescricaoProduto: "Produto 1",
      CorProduto: "Azul",
      TamanhoProduto: "M",
      OD: "1",
      QtdFaturada: 1,
      QtdDevolvida: 1,
      PrecoUnitario: 100,
      ValorLiquido: 100,
      NomeProduto: "Produto 1 Azul M",
    },
  ];

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xl">
      <DialogTitle>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="h4">Detalhes da Nota Fiscal</Typography>
          <IconButton onClick={onClose} size="small">
            <Close />
          </IconButton>
        </div>
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={2} style={{ marginBottom: "1.5rem" }}>
          <Grid item xs={12} md={6}>
            <Typography variant="h4">Número da NF</Typography>
            <Typography variant="caption">
              {invoice.NumeroNf} - {invoice.SerieNf}
            </Typography>
          </Grid>

          <Grid item xs={12} md={6}>
            <Typography variant="h4">Data de Emissão</Typography>
            <Typography variant="caption">{invoice?.DataEmissao}</Typography>
          </Grid>

          <Grid item xs={12}>
            <Typography variant="h4">Itens</Typography>
            {items.length > 0 ? (
              <ToolkitTable
                dataTable={items}
                columnModel={itemsColumnModel}
                keyField="ItemSequencial"
                pagination={false}
                style={{
                  boxShadow: "none",
                }}
              />
            ) : (
              <Typography
                variant="caption"
                align="center"
                style={{ padding: "2rem 0" }}
              >
                Nenhum item encontrado para esta nota fiscal.
              </Typography>
            )}
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
}
